
/**
 * Get cart item count from Shopify Cart API
 * @param {boolean} returnFullCart - If true, returns full cart object; if false, returns only item count
 * @returns {Promise<number|object>} Cart item count or full cart object
 */
async function getCartItemCount(returnFullCart = false) {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const cart = await response.json();
    
    if (returnFullCart) {
      return cart;
    }
    
    return cart.item_count || 0;
  } catch (error) {
    console.error('Error fetching cart item count:', error);
    return returnFullCart ? null : 0;
  }
}

/**
 * Get cart data formatted for Zapiet API
 * @param {string} shop - The merchant's myshopify.com store url (e.g., 'florisflower.myshopify.com')
 * @returns {Promise<object>} Formatted cart data with shop and shoppingCart array
 */
async function getCartForZapiet(shop) {
  try {
    const cart = await getCartItemCount(true);
    
    if (!cart || !cart.items) {
      return {
        shop: shop,
        shoppingCart: []
      };
    }

    // Format cart items for Zapiet API
    const shoppingCart = cart.items.map(item => ({
      variantId: item.variant_id,
      quantity: item.quantity,
      productId: item.product_id,
      title: item.product_title,
      variantTitle: item.variant_title,
      price: item.price,
      linePrice: item.line_price
    }));

    return {
      shop: shop,
      shoppingCart: shoppingCart
    };
  } catch (error) {
    console.error('Error formatting cart for Zapiet:', error);
    return {
      shop: shop,
      shoppingCart: []
    };
  }
}

// Export functions for use in other scripts
if (typeof window !== 'undefined') {
  window.getCartItemCount = getCartItemCount;
  window.getCartForZapiet = getCartForZapiet;
}
  